import { getDbRef, readProductData } from "../../../api/helpers/rtdbHelper";
import router from "../../../router";

export default {
  state: {
    user: '',
    table: '',
    sharedCart: {},
    showModal: false,
  },
  getters: {
    getUser: (state) => {
      return state.user;
    },
    getSharedCartProps: (state) => {
      const { user, table } = state;
      return {
        user,
        table,
      };
    },
    getSharedCart: (state) => {
      return state.sharedCart;
    },
    getPeople: (state) => {
      if (state.sharedCart) {
        const people = Object.keys(state.sharedCart);
        return people.length > 0 ? people.sort((x, y) => {
          return x === state.user ? -1 : y === state.user ? 1 : 0
        }) : [];
      }
      return [];
    },
    getModalProp: (state) => {
      return state.showModal;
    }
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_TABLE_NUMBER(state, payload) {
      state.table = payload;
    },
    SET_SHARED_CART(state, payload) {
      state.sharedCart = payload;
    },
    SET_MODAL(state, payload) {
      state.showModal = payload;
    },
    RESET_USER(state) {
      state.user = '';
    }
  },
  actions: {
    setUser({ commit }, payload) {
      commit('SET_USER', payload);
      localStorage.setItem('user', payload);
    },
    addUserToTable({ commit }, payload) {
      commit('SET_USER', payload);
    },
    setTableNumber({ commit }, payload) {
      commit('SET_TABLE_NUMBER', payload);
    },
    async getTableOrder({ commit, state, getters }, payload) {
      const sharedCart = await readProductData(state.table, payload);
      commit('SET_SHARED_CART', sharedCart);

      const dbRef = getDbRef(payload, state.table);
      dbRef.on('child_changed', async () => {
        const newData = await readProductData(state.table, payload);
        commit('SET_SHARED_CART', newData);
      });
      
      dbRef.on('child_added', async (data) => {
        if (data.key === 'status' && data.val() === 'complete') {
          const { storeid } = router.currentRoute.params;
          const { path, query } = router.currentRoute;
          if (path !== `/store/${storeid}` ) {
            router.push({ path: `/store/${storeid}/`, query })
          }
          commit('SET_MODAL', true);
          setTimeout(() => {
            commit('SET_MODAL', false);
            commit('Set_Items', [], { root: true });
          }, 4000)
        }
        else if (!getters.getPeople.includes(data.key)) {
          const newData = await readProductData(state.table, payload);
          commit('SET_SHARED_CART', newData);
        }
      });

      dbRef.on('child_removed', async () => {
        const newData = await readProductData(state.table, payload);
        const updatedCart = newData || {};
        commit('SET_SHARED_CART', updatedCart);
      });
    },
    async resetUser() {
      localStorage.removeItem('user');
    },
    async resetModal({ commit }) {
      commit('SET_MODAL', false);
    }
  },
}